// extracted by mini-css-extract-plugin
module.exports = {"badge":"TabNavItem_badge__1gkol","error":"TabNavItem_error__xbTWp","label":"TabNavItem_label__22IXe"};